import { useState, useEffect }      from 'react'
import { useSubscription }          from '../../hooks/external/proprietary/handlers/useSubscription.js'
import { useCompsAPI }              from '../../hooks/external/proprietary/useCompsAPI.js'
import { getSectorTransactions }    from '../../api/transactions.js'
import Navbar                       from '../nav/index.js'
import { Outlet }                   from 'react-router-dom'
import PaywallBlock                 from '../skeletons/PaywallBlock.js'


const Main = () => {
    const { handleSubscriptionsProxy, handlePaymentMethodsProxy }   = useSubscription()
    const { getCategories, getCosForCategory }                      = useCompsAPI();

    //Data returned from thin-proxy endpoints hitting the epoynmouus stripe table
    const [subscription, setSubscription]                       = useState(null)
    const [paymentMethod, setPaymentMethod]                     = useState(null)
    // const [product, setProduct]                                 = useState(null)

    // Data returned from our proprietary endpoints for consumption by NavBar Main Feature Node Boundary

    // Data returned from our proprietary endpoints for consumption by Core Dashboards (Outlet) Main Feature Node Boundary
    const [compsCategories, setCompsCategories]                 = useState(null)
    const [selectedCompsCategoryId, setSelectedCompsCategoryId] = useState([])
    const [companies, setCompanies]                             = useState(null)
    const [selectedCompanyIds, setSelectedCompanyIds]           = useState([])
    const [compsTiles, setCompsTiles]                           = useState(null)
    const [selectedCompsTileIds, setSelectedCompsTileIds]       = useState([null, null])
    const [selectedFootballFieldCoId, setSelectedFootballFieldCoId] = useState(null)
    const [transCategories, setTransCategories]                 = useState(null)
    const [selectedTransCategoryId, setSelectedTransCategoryId] = useState(null)
    const [transactions, setTransactions]                       = useState(null)
    const [selectedTransactionIds, setSelectedTransactionIds]   = useState([])
    const [transTiles, setTransTiles]                           = useState(null)
    const [selectedTransTileIds, setSelectedTransTileIds]       = useState([null, null])

    // Gates
    const [compsIsLoading, setCompsIsLoading]                   = useState(true)
    const [transactionsIsLoading, setTransactionsIsLoading]     = useState(true)
    const [isPaymentRequired, setIsPaymentRequired]             = useState(false)

    // ======== Main Node 1: Nabar ======== //
    useEffect(() => {
        //can decide if we need loading gate here to pass through to the consumer of this data in main node 1 (navbar)
        // or if by time customer navigates to consumer, the response will probably have arrived or the network already
        // since its a two-hop request: client -> backend -> stripe -> backend -> client
        const fetchSubscription = async () => {
            try {
                // this is a hook because its calling a hook (-> handle layer -> call Layer -> baseAPIinstance which uses getAccessTokenSilently to append to authorization header, making it a hook, meaning everything that calls it in the chain has to become a hook)
                const subscription = await handleSubscriptionsProxy()
                console.log("[Subscriptions] thin proxy res:", subscription)
                // when stateful variable used in the navbar component tree, if subscription === null, then render the html tree that has a div which in its inner html text says 'Subscription Details Cannot Be Displayed at This Time'
                // if pass this above gate in the component where its used, then decide which details to render in an html tree by grabbing them from what should be props hung on this object
                // let back do the DTO stuff to the response from stripe servers when asking for details with stripe_customer_id, so the respomnse we get here is a simple object with straightforward top level props we dot notation into to hydrate the success side render of the UI
                setSubscription(subscription)

            } catch (error) {
                console.error('✗ [ERROR] loading subscription:', error.message)
                // logs undefined on network errors — no response = no response prop on the error object = no status code because status codes are only on the response prop on the error object
                console.error('✗ [STATUS]:', error.response?.status)
            }
        }
        fetchSubscription()
    }, []) 

    useEffect(() => {
        //can decide if we need loading gate here to pass through to the consumer of this data in main node 1 (navbar)
        // or if by time customer navigates to consumer, the response will probably have arrived or the network already
        // since its a two-hop request: client -> backend -> stripe -> backend -> client
        const fetchPaymentMethod = async () => {
            try {
                // this is a hook because its calling a hook (-> handle layer -> call Layer -> baseAPIinstance which uses getAccessTokenSilently to append to authorization header, making it a hook, meaning everything that calls it in the chain has to become a hook)
                const paymentMethod = await handlePaymentMethodsProxy()
                console.log("[Payment Methods] thin proxy res:", paymentMethod)
                // when stateful variable used in the navbar component tree, if paymentMethod === null, then render the html tree that has a div which in its inner html text says 'Subscription Details Cannot Be Displayed at This Time'
                // if pass this above gate in the component where its used, then decide which details to render in an html tree by grabbing them from what should be props hung on this object
                // let back do the DTO stuff to the response from stripe servers when asking for details with stripe_customer_id, so the respomnse we get here is a simple object with straightforward top level props we dot notation into to hydrate the success side render of the UI
                setPaymentMethod(paymentMethod)

            } catch (error) {
                console.error('✗ [ERROR] loading subscription:', error.message)
                // logs undefined on network errors — no response = no response prop on the error object = no status code because status codes are only on the response prop on the error object
                console.error('✗ [STATUS]:', error.response?.status)
            }
        }
        fetchPaymentMethod()
    }, [])   

    // ======== Main Node 2: Outlet (Companies) ======== //
    useEffect(() => {
        const fetchCompsCategories = async () => {
            try {
                const response = await getCategories()
                setCompsCategories(response.data)
                setSelectedCompsCategoryId(response.data[0].id)
                console.log("[SUCCESS]: comps category picked from list of comp cat ids returned from (comps) categories table: ", response.data[0].id)
            } catch (error) {
                console.error('✗ [ERROR] loading comps categories:', error.message)
                // logs undefined on network errors — no response = no response prop on the error object = no status code because status codes are only on the response prop on the error object
                console.error('✗ [STATUS]:', error.response?.status)
            }
        }
        fetchCompsCategories()
    }, [])

    useEffect(() => {
        if (compsCategories === null) return
        
        const fetchCompsCompaniesForCategory = async () => {
            setCompsIsLoading(true)
            try {
                const response = await getCosForCategory({ selectedSectorId: selectedCompsCategoryId }) // note to flow updated name through backend so we can use object key/value pair shorthand syntax
                //console.log('COS FOR CATEGORY DATA:', response.data)
                setCompanies(response.data)
                // Initialize public comps component with first 5 companies (0-4), skip 5, then next 3 (10-12) for 8 total
                const initialCosSelected = response.data.slice(0,8).map(c => c.id)
                setSelectedCompanyIds(initialCosSelected)
                
                console.log("[SUCCESS]: returned cos for category for comps component, initialized with first 8 companys from that category for charts", initialCosSelected)
                // select random index (company) from companies returned for category selected
                const randomIndexForInitialFootbalFieldCo = Math.floor(Math.random() * response.data.length)
                // Initialize footballfield component's "company id state variable" lifted to main with that random company from companies available in the category selected by user
                setSelectedFootballFieldCoId(response.data[randomIndexForInitialFootbalFieldCo].id) // may move this down until after all the sections are made for comps and trans now that the co is going to be wired and therefore calc from both sets of data
                setCompsIsLoading(false)
            } catch (error) {
                // logs response as undefined on network errors where didnt reach backend! i.e. no response = no response prop on the error object = no data prop on response object and no status code on response object because data and status codes are only on the response prop on the error object
                console.error('✗ [ERROR] loading comps companies:', error.response ? error.response.data.message : error.message)
                console.error('✗ [STATUS]:', error.response?.status)
                if (error.response?.status === 402) setIsPaymentRequired(true)
            }
        }
        fetchCompsCompaniesForCategory()
    }, [selectedCompsCategoryId])

    // Eventually will refactor to an API call and keep all this in a table in the db set in stone
    // instead of having it here on the front end where we can easily / accidentally break it or llm can accidentally change it 
    const compsTilesResponse = [
        { id: 1,  name: 'Enterprise Value',            field: 'enterpriseValue'             },
        { id: 2,  name: 'Market Cap',                  field: 'marketCapitalization'        },
        { id: 7,  name: 'Forward Revenue Growth',      field: 'forwardRevenueGrowth'        },
        { id: 5,  name: 'Forward Revenue Multiple',    field: 'nextYearRevenueMultiple'     },
        { id: 6,  name: 'Current Revenue Growth',      field: 'currentRevenueGrowth'        },
        { id: 4,  name: 'Current Revenue Multiple',    field: 'currentYearRevenueMultiple'  },
        { id: 3,  name: 'LTM Revenue Multiple',        field: 'ttmRevenueMultiple'          },
        { id: 16, name: 'LTM Gross Margin',            field: 'ttmGrossMargin'              },        
        { id: 9,  name: 'LTM EBITDA Margin',           field: 'ttmEbitdaMargin'             },
        { id: 8,  name: 'LTM EBITDA Multiple',         field: 'ttmEbitdaMultiple'           },
        { id: 14, name: 'Forward Earnings Growth',     field: 'forwardEarningsGrowth'       },
        { id: 12, name: 'Forward Earnings Multiple',   field: 'nextYearPeMultiple'          },
        { id: 13, name: 'Current Earnings Growth',     field: 'currentEarningsGrowth'       },
        { id: 11, name: 'Current Earnings Multiple',   field: 'currentYearPeMultiple'       },
        { id: 10, name: 'LTM Earnings Multiple',       field: 'ttmPeMultiple'               },
        { id: 15, name: 'Rule of 40',                  field: 'ruleOf40'                    },
        { id: 17, name: 'Dividend Yield',              field: 'dividendYield'               },
        { id: 18, name: 'Net Debt / Market Equity',    field: 'netDebtToMarketEquity'       },
    ]

    useEffect(() => {
        setCompsTiles(compsTilesResponse)
    }, [])

    // ======== Main Node 2: Outlets (Transactions) ======== // 
    const transCategoriesResponse = [
        { id: 'big-tech',                          name: 'Big Tech' },
        { id: 'computing-infrastructure',          name: 'Computing Infrastructure' },
        { id: 'physical-infrastructure',           name: 'Physical Infrastructure' },
        { id: 'take-private',                      name: 'Take-Private' },
        { id: 'internet',                          name: 'Internet' },
        { id: 'industrials-and-industrial-tech',   name: 'Industrials and Industrial Tech' },
        { id: 'software-SaaS',                     name: 'Software / SaaS' }
    ]

    useEffect(() => {
        setTransCategories(transCategoriesResponse)
        setSelectedTransCategoryId(transCategoriesResponse[0].id)
        console.log("[SUCCESS] transactions category id picked from list of transaction cat ids returned from (trans) categories table: ", transCategoriesResponse[0].id)
    }, [])

    // Transaction data fetch - separate useEffect to avoid cross-triggering with comps
    useEffect(() => {
        if (transCategories === null) return
        
        const fetchTransactionsForCategory = async () => {
            setTransactionsIsLoading(true)
            try {
                const response = await getSectorTransactions(`/${selectedTransCategoryId}.json`) //
                setTransactions(response.data)
                // Initialize with first 10 transactions from response
                const initialTransSelected = [...response.data.slice(0, 1), ...response.data.slice(2, 4), ...response.data.slice(7, 9), ...response.data.slice(11, 12)].map(t => t.id)
                setSelectedTransactionIds(initialTransSelected)
                console.log("[SUCCESS]: returned trans for category for trans component, initialized with 8 random transactions from that category for charts", initialTransSelected)
                setTransactionsIsLoading(false)
            } catch (error) {
                console.error('✗ [ERROR] loading transactions:', error.message)
                // logs undefined on network errors — no response = no response prop on the error object = no status code because status codes are only on the response prop on the error object
                console.error('✗ [STATUS]:', error.response?.status)
            }
        }
        fetchTransactionsForCategory()
    }, [selectedTransCategoryId]) 
    
    const transTilesResponse = [
        { id: 'dealSize',           name: 'Deal Size',              field: 'dealSize' },
        { id: 'premiumPaid',        name: 'Premium Paid',           field: 'premiumPaid' },
        { id: 'ttmRevenueMultiple', name: 'LTM Revenue Multiple',   field: 'ttmRevenueMultiple' },
        { id: 'ttmRevenueGrowth',   name: 'LTM Revenue Growth',     field: 'ttmRevenueGrowth' },
        { id: 'ttmEbitdaMultiple',  name: 'LTM EBITDA Multiple',    field: 'ttmEbitdaMultiple' },
        { id: 'ttmEbitdaMargin',    name: 'LTM EBITDA Margin',      field: 'ttmEbitdaMargin' }
    ]

    useEffect(() => {
        setTransTiles(transTilesResponse)
    }, [])

    // ======== Main Feature Node 4: Outlets (Leaderboard Prices) ======== //        

    // debugger;

    return (
        <>
            {/* === Main Node 1 in Core [Dashboards] Feature Node: Proprietary Navbar === */}
            <Navbar 
                subscription    ={subscription}
                paymentMethod   ={paymentMethod}
            />

            {/* === Main Node 2 in Core [Dashboards] Feature Node: Page Content === */}
            { isPaymentRequired  
                ? <PaywallBlock/>  
                : <Outlet context={{
                // Public Comps
                compsCategories, // always read only in children, API call lives in component and values passed down
                selectedCompsCategoryId,
                onCompsCategorySelectionChange: setSelectedCompsCategoryId,
                companies,
                selectedCompanyIds,
                onCompanySelectionChange: setSelectedCompanyIds,
                compsTiles,
                selectedCompsTileIds,
                onCompsTileSelectionChange: setSelectedCompsTileIds,
                // Transactions
                transCategories, // always read only in children, API call lives in component and values passed down
                selectedTransCategoryId,
                onTransCategorySelectionChange: setSelectedTransCategoryId,
                transactions,
                selectedTransactionIds,
                onTransactionSelectionChange: setSelectedTransactionIds,
                transTiles, // always read only in children, API call lives in component and values passed down
                selectedTransTileIds,
                onTransTileSelectionChange: setSelectedTransTileIds,
                // Football Field specific
                selectedFootballFieldCoId,
                onSelectedFootballFieldCoIdChange: setSelectedFootballFieldCoId,
                // Leaderboard
                // Loading states
                compsIsLoading,
                transactionsIsLoading,
                }} />
            }
        </>
    )
}

export default Main
